import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { isNative } from 'app/styles';
import RStat from 'modules/stats/rStat.component';
import Avatar from 'modules/user/UAvatar.component';
import { getTimestamp } from 'app/utils/numbers';
import {
  Text,
  View,
  SecondaryText,
  Image,
  BodyText,
  Box,
  Pressable,
} from 'modules/styled';
import { goToProfile } from 'modules/navigation/navigation.actions';

export default memo(AvatarBox);

AvatarBox.propTypes = {
  noLink: PropTypes.bool,
  avatarText: PropTypes.func,
  twitter: PropTypes.bool,
  type: PropTypes.string,
  user: PropTypes.object,
  size: PropTypes.number,
  showRelevance: PropTypes.bool,
  repost: PropTypes.bool,
  postTime: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  setSelected: PropTypes.func,
  navigationCallback: PropTypes.func,
  vertical: PropTypes.bool,
};

function AvatarBox(props) {
  const {
    user,
    showRelevance,
    type,
    setSelected,
    size,
    postTime,
    repost,
    avatarText,
    noLink,
    navigationCallback,
    vertical,
  } = props;
  const dispatch = useDispatch();

  if (!user) return null;

  let { handle } = user;
  if (type !== 'invite' && handle) handle = `@${handle}`;

  let timestamp;
  if (postTime) {
    timestamp = ' • ' + getTimestamp(postTime);
  }

  const handleEl = handle && !vertical && (
    <SecondaryText>
      {handle} {timestamp}
    </SecondaryText>
  );

  const repostIcon = repost && (
    <Image
      resizeMode={'contain'}
      source={require('public/img/reposted.png')}
      sx={{ width: 3, height: 3, mr: 0.2, mb: 2 }}
    />
  );

  const showRel = showRelevance && !avatarText && user?.relevance?.reputation > 0.01;

  return (
    <Box>
      <Pressable
        disabled={noLink}
        to={`/user/profile/${user.handle}`}
        nativeAction={() => {
          setSelected ? setSelected(user) : dispatch(goToProfile(user));
          navigationCallback && navigationCallback();
        }}
        webAction={() => navigationCallback && navigationCallback()}
      >
        <View sx={{ alignItems: 'center', flexDirection: vertical ? 'column' : 'row' }}>
          <Avatar size={size} user={user} noLink />
          {repostIcon}
          <View
            sx={{
              ml: vertical ? 0 : avatarText ? 1.5001 * 8 : 1,
              alignItems: vertical ? 'center' : 'flex-start',
            }}
          >
            <Text>
              <UserName user={user} showRel={showRel} />
              {avatarText ? <Text> {avatarText()}</Text> : null}
            </Text>
            {handleEl}
          </View>
        </View>
      </Pressable>
    </Box>
  );
}

UserName.propTypes = {
  user: PropTypes.object,
  showRel: PropTypes.bool,
};

export function UserName({ user, showRel }) {
  const elipses = isNative
    ? {}
    : {
        // overflowText: 'elipses',
        // display: 'inline-block',
        // verticalAlign: 'bottom',
        maxWidth: 12 * 8,
        whiteSpace: 'nowrap',
      };

  return (
    <Fragment>
      <BodyText
        // numberOfLines={1}
        sx={{
          overflow: 'hidden',
          lineHeight: 18,
          ...elipses,
        }}
        testID="name"
      >
        {user.name}
      </BodyText>
      {showRel && (
        <Text>
          {' '}
          <RStat noSpace inline={1} align={'baseline'} size={1} user={user} />
        </Text>
      )}
    </Fragment>
  );
}
